let mapMockData = [{
        coordinate: [
            '87.616842,43.82539', //其他地点
            '114.492897,36.63641' //中心地点
        ],
        name: '乌鲁木齐'
    },
    {
        coordinate: [
            '113.264385,23.129112',
            '114.492897,36.63641'
        ],
        name: '广州'
    },
    {
        coordinate: [
            '114.085947,22.547',
            '114.492897,36.63641'
        ],
        name: '深圳'
    },
    {
        coordinate: [
            '104.066143,30.573095',
            '114.492897,36.63641'
        ],
        name: '成都'
    },
    {
        coordinate: [
            '112.938888,28.228272',
            '114.492897,36.63641'
        ],
        name: '长沙'
    },
    {
        coordinate: [
            '126.535319,45.803131',
            '114.492897,36.63641'
        ],
        name: '哈尔滨'
    },
    {
        coordinate: [
            '125.323628,43.817001',
            '114.492897,36.63641'
        ],
        name: '长春'
    },
    {
        coordinate: [
            '118.110221,24.490474',
            '114.492897,36.63641'
        ],
        name: '厦门'
    },
    {
        coordinate: [
            '111.748426,40.842723',
            '114.492897,36.63641'
        ],
        name: '呼和浩特'
    },
    {
        coordinate: [
            '117.191782,39.115158',
            '114.492897,36.63641'
        ],
        name: '贵阳'
    },
    {
        coordinate: [
            '119.586579,39.942531',
            '114.492897,36.63641'
        ],
        name: '秦皇岛'
    },
    {
        coordinate: [
            '117.201538,39.085294',
            '114.492897,36.63641'
        ],
        name: '天津'
    },
    {
        coordinate: [
            '121.473658,31.230378',
            '114.492897,36.63641'
        ],
        name: '上海'
    },
]
export default mapMockData;